/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES clipping 料金システム用 API
 * PR TIMES clipping 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIsApplyingSportTimesProgramResponseData
 */
export interface GetIsApplyingSportTimesProgramResponseData {
    /**
     * SPORT TIMESプログラムが適用されているか
     * @type {boolean}
     * @memberof GetIsApplyingSportTimesProgramResponseData
     */
    isApplyingSportsTimesProgram: boolean;
}

export function GetIsApplyingSportTimesProgramResponseDataFromJSON(json: any): GetIsApplyingSportTimesProgramResponseData {
    return GetIsApplyingSportTimesProgramResponseDataFromJSONTyped(json, false);
}

export function GetIsApplyingSportTimesProgramResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIsApplyingSportTimesProgramResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isApplyingSportsTimesProgram': json['is_applying_sports_times_program'],
    };
}

export function GetIsApplyingSportTimesProgramResponseDataToJSON(value?: GetIsApplyingSportTimesProgramResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'is_applying_sports_times_program': value.isApplyingSportsTimesProgram,
    };
}

